import axios from "axios";

import auth from "./auth";
import basket from "./basket";
import cart from "./cart";
import catalog from "./catalog";
import dadata from "./dadata";
import delivery from "./delivery";
import edost from "./edost";
import formsV2 from "./formsV2";
import manager from "./manager";
import orders from "./orders";
import product from "./product";
import sdek from "./sdek";
import sections from "./sections";
import user from "./user";

const config = {
  API_SERVER_URL: "/api",
  API_URL: "/bxApi",
  SERVICE_DATABASE_API_URL: "/database",
  // SERVICE_DATABASE_API_URL: "http://localhost:3020/database",
};
if (
  typeof window !== "undefined" &&
  window.location.host.includes("farkop.ru")
) {
  config.API_URL = "https://farkop.ru/bxApi";
}

export const ApiClient = {
  auth: auth(axios, config),
  basket: basket(axios, config),
  catalog: catalog(axios, config),
  cart: cart(axios, config),
  delivery: delivery(axios, config),
  edost: edost(axios, config),
  formsV2: formsV2(axios, config),
  manager: manager(axios, config),
  orders: orders(axios, config),
  product: product(axios, config),
  sdek: sdek(axios, config),
  dadata: dadata(axios, config),
  sections: sections(axios, config),
  user: user(axios, config),
};
